import {
	OPEN_CONTEXT_PANEL,
	HIDE_CONTEXT_PANEL,
	ADD_STEP_TO_CONTEXT,
	UPDATE_STEP_CONTEXT_OUTPUT_DATA,
	REMOVE_STEP_FROM_CONTEXT,
	ADD_CONTEXT_VARIABLE,
	DELETE_CONTEXT_VARIABLE,
	UPDATE_CONTEXT_VARIABLE,
	SET_CONTEXT_VARIABLES,
	SET_CONTEXT_CREDENTIALS_MANAGEMENT,
	SET_CONTEXT,
	ADD_CONTEXT_TRIGGER,
	DELETE_CONTEXT_TRIGGER,
	UPDATE_CONTEXT_TRIGGER,
	TOGGLE_CONTEXT_TRIGGER,
	SET_CONTEXT_FILTER_OPTIONS,
	CHANGE_CONTEXT_FILTER_OPTION,
	SET_FLOW_CONFIGURATION
} from "redux/constants/flowDesigner";
import {
	removeProperty,
	convertToUndescoreSeparatedString
} from "helpers/common";
import {} from "redux/constants/flowDesigner";
import { hideComponentData } from "helpers/common";

const initialState = {
 	showContextPanel: false,
 	context: {
  		settings: {},
  		flow_name: "",
  		steps: {},
  		triggers: {},
  		variables: {},
  		tenant_id: "",
      	invocation: {},
      session: null,
      flow_configuration: {},
      shared_flow_configurations: {}
 	},
  	contextFilterOptions: {
  		componentSteps: true,
  		connectorSteps: true,
  		flowSteps: true,
  		successfulSteps: true,
  		failedSteps: true,
  		inProgressSteps: true,
  		stepsWithDataChanges: true,
  		stepsWithoutDataChanges: true,
  		stepsWithUserDefinedFields: true,
  		stepsWithoutUserDefinedFields: true,
  		runtimeErrors: true,
  		authorizationErrors: true,
  		networkErrors: true,
  		userTriggeredSteps: true,
  		systemTriggerredSteps: true
 	}
};

const editorContext = (state = initialState, { type, payload }) => {
	let triggerName = payload?.triggerName
		? convertToUndescoreSeparatedString(payload.triggerName)
		: "";

	switch (type) {
		case SET_FLOW_CONFIGURATION:
			return {
				...state,
				context: {
					...state.context,
					flow_configuration: payload
				}
			};
		case SET_CONTEXT: {
			const { credentialsManagement, ...restPayload } = payload;
			return {
				...state,
				context: hideComponentData({
					...state.context,
					...restPayload
				})
			};
		}
		case SET_CONTEXT_CREDENTIALS_MANAGEMENT: {
			const crData = {};
			if (payload?.length) {
				payload.forEach((credential) => {
					const crd = credential?.application;
					if (crd?.name) {
						const fieldName = crd.name.replace(/ /g, "_");
						crData[fieldName] = crd;
					}
				});
			}
			return {
				...state,
				context: hideComponentData({
					...state.context,
					credentialsManagement: crData
				})
			};
		}
		case OPEN_CONTEXT_PANEL:
			return {
				...state,
				showContextPanel: true
			};
		case HIDE_CONTEXT_PANEL:
			return {
				...state,
				showContextPanel: false
			};
		case ADD_STEP_TO_CONTEXT: {
			let stepData = { ...payload.data };
			stepData = removeProperty(stepData, "isPassword");

			return {
				...state,
				context: hideComponentData({
					...state.context,
					steps: {
						...state.context.steps,
						[payload.componentKey]: stepData
					}
				})
			};
		}
		case UPDATE_STEP_CONTEXT_OUTPUT_DATA: {
			let outputData = payload.data;

			if (outputData?.console_logs) {
				delete outputData.console_logs;
			}

			return {
				...state,
				context: {
					...state.context,
					steps: {
						...state.context.steps,
						[payload.componentKey]: {
							...state.context.steps[payload.componentKey],
							outputData: outputData
						}
					}
				}
			};
		}
		case REMOVE_STEP_FROM_CONTEXT: {
			const { [payload.componentKey]: step, ...restSteps } =
				state.context.steps || {};
			return {
				...state,
				context: {
					...state.context,
					steps: restSteps
				}
			};
		}
		case ADD_CONTEXT_TRIGGER: {
			let initialData =
				triggerName === "rest"
					? {
							inputData: {
								method: ["GET"],
								url: "",
								headers: [],
								body: {}
							},
							outputData: { headers: [], body: {} }
						}
					: {};
			initialData.disabled = false;

			if (triggerName === "blue_prism_delta") {
				initialData.message = "";
			}

			return {
				...state,
				context: {
					...state.context,
					triggers: {
						...state.context.triggers,
						[triggerName]: initialData
					}
				}
			};
		}
		case UPDATE_CONTEXT_TRIGGER:
			return {
				...state,
				context: {
					...state.context,
					triggers: {
						...state.context.triggers,
						[triggerName]: {
							...state.context.triggers[triggerName],
							...payload.data
						}
					}
				}
			};
		case DELETE_CONTEXT_TRIGGER: {
			const { [triggerName]: __, ...restTriggers } = state.context.triggers;
			return {
				...state,
				context: {
					...state.context,
					triggers: restTriggers
				}
			};
		}
		case TOGGLE_CONTEXT_TRIGGER:
			return {
				...state,
				context: {
					...state.context,
					triggers: {
						...state.context.triggers,
						[triggerName]: {
							...state.context.triggers[triggerName],
							disabled: !state.context.triggers[triggerName]?.disabled
						}
					}
				}
			};
		case ADD_CONTEXT_VARIABLE:
			return {
				...state,
				context: {
					...state.context,
					variables: {
						...state.context.variables,
						[payload.componentKey]: []
					}
				}
			};
		case DELETE_CONTEXT_VARIABLE: {
			const { [payload.componentKey]: _, ...restVariables } =
				state.context.variables;
			return {
				...state,
				context: {
					...state.context,
					variables: restVariables
				}
			};
		}
		case UPDATE_CONTEXT_VARIABLE: {
			const vars = {};
			payload.data.forEach((v) => {
				vars[v.variableName] = v.variableValue;
			});
			return {
				...state,
				context: {
					...state.context,
					variables: {
						...state.context.variables,
						[payload.id]: vars
					}
				}
			};
		}
		case SET_CONTEXT_VARIABLES:
			return {
				...state,
				context: {
					...state.context,
					variables: payload.variables
				}
			};
		case SET_CONTEXT_FILTER_OPTIONS:
			return {
				...state,
				contextFilterOptions: payload
			};
		case CHANGE_CONTEXT_FILTER_OPTION:
			return {
				...state,
				contextFilterOptions: {
					...state.contextFilterOptions,
					[payload]: !state.contextFilterOptions[payload]
				}
			};
		default:
			return state;
	}
};

export default editorContext;
